export const ENDPOINTS = {
    // REPORTS
    
    PRIORITIZE_VEHICLES: 'api/v2/reports/prioritize-vehicles/', // POST, DELETE
    
    CHANGE_PASSWORD: 'api/v2/users/change-password',
    
    // GET
    NOTFICATIONS : 'api/notifications',
    
    // POST
    NOTIFICATIONS_MARK_AS_SEEN: 'api/notifications/mark-as-seen',
    NOTIFICATIONS_MARK_AS_READ: 'api/notifications/{}/mark-as-read',    
    NOTIFICATIONS_MARK_ALL_AS_READ: 'api/notifications/mark-all-as-read',
    
    UPLOAD_SOLD_FILE: 'api/upload-sold-file/'
} as const;
